<template>
	<div>
		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">

				<div class="row pt-4">

          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-4">
                <a class="element-box el-tablo" href="#">
                  <div class="label">IN</div>
                  <div class="value">{{ total.in }}</div>
                </a>
              </div>
              <div class="col-4">
                <a class="element-box el-tablo" href="#">
                  <div class="label">OUT</div>
                  <div class="value">{{ total.out }}</div>
                </a>
              </div>
              <div class="col-sm-4">
                <a class="element-box el-tablo" href="#">
                  <div class="label">Remaining</div>
                  <div class="value">{{ total.result }}</div>
                </a>
              </div>
            </div>
          </div>

					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.navigation.transactions }}
							</h6>

							<div class="element-box-tp">

								<div class="alert" v-if="status > 200">
									<span v-if="status == 401">
										{{ t.error.access_denied_content }}
									</span>
									<span v-if="status == 404">
										{{ t.error.notfound_content_list }}
									</span>
								</div>

                <div class="table-responsive" v-if="w > 700">
                  <table class="table table-bordered table-lg table-v2 table-striped">
                    <thead>
                    <tr>
                      <th>#</th>
                      <th class="w50">{{ t.finance.currency }}</th>
                      <th></th>
                      <th>{{t.transaction}}</th>
                      <th class="w150">{{t.amount}}</th>
                      <th class="w150">
                        {{ t.old_real_money }}
                      </th>
                      <th class="w150">{{ t.new_real_money }}</th>
                      <th>{{t.status}}</th>
                      <th class="text-danger">{{ t.created_at }}</th>
                      <th></th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in transactions">
                      <td class="text-center">
                        {{ row.id }}
                      </td>
                      <td>{{ row.currency.iso_code }}</td>
                      <td>
                        <router-link :to="{name: 'userprofile', params: {id: row.user.id}}">
                          <span :id="'cu_'+row.id" class="ml-2 pull-right col-12">@{{row.user.username}}</span>
                        </router-link>
                      </td>
                      <td>
                        {{row.info}}
                        <span v-if="row.game">
                          > <span class="text-danger">{{ row.game.name }}</span> by {{ row.game.vendor.name }}
                        </span>

                        <template v-if="row.type.key === 'placed_sport_betting' || row.type.key === 'bet_earnings_deposit' || row.type.key === 'cancelled_bet_stake_rollback' || row.type.key === 'incorrectly_bet_earnings_rollback'">
                          <router-link target="_blank" :to="{name: 'bets', params: {id: row.dataId} }" class="pull-right">
                            <i class="os-icon os-icon-mail-18" />
                          </router-link>
                        </template>
                      </td>
                      <td class="text-right text-primary">
                        <strong>{{ row.type.operator }}{{ row.amount | toMoney(row.currency) }}</strong>
                      </td>
                      <td class="text-right">
                        <div v-if="row.oldRealMoney != row.newRealMoney">
                          {{ row.oldRealMoney | toMoney(row.currency) }}
                        </div>
                        <div v-if="row.oldBonus != row.newBonus">
                          <i class="fa fa-bold pull-left pt-1 text-danger has-tooltip"></i>
                          <span class="text-danger">
                            {{ row.oldBonus | toMoney(row.currency) }}
                          </span>
                        </div>
                      </td>
                      <td class="text-right">
                        <div v-if="row.oldRealMoney != row.newRealMoney">
                          {{ row.newRealMoney | toMoney(row.currency) }}
                        </div>
                        <div v-if="row.oldBonus != row.newBonus">
                          <i class="fa fa-bold pull-left pt-1 text-danger has-tooltip"></i>
                          <span class="text-danger">
                            {{ row.newBonus | toMoney(row.currency) }}
                          </span>
                        </div>
                      </td>
                      <td class="text-center">
                        {{ row.status }}
                      </td>
                      <td class="text-right text-danger">{{ dateTimeFormat(row.addedAt) }}</td>
                      <td class="w20 text-center">
                        <span :id="'c_'+row.id"><i class="icon-info"></i></span>
                        <b-popover :target="'c_'+row.id" triggers="hover focus">
                          <div class="row p-0">
                            <div class="col-12 p-0">
                              <div class="listy b-b">
																<span class="label">
																	{{ t.old_real_money }}
																</span>
                                {{ row.oldRealMoney | toMoney(row.currency) }}
                              </div>
                            </div>
                            <div class="col-12 p-0">
                              <div class="listy b-b">
																<span class="label">
																	{{ t.new_real_money }}
																</span>
                                {{ row.newRealMoney | toMoney(row.currency) }}
                              </div>
                            </div>
                            <div class="col-12 p-0">
                              <div class="listy b-b">
																<span class="label">
																	{{ t.old_bonus }}
																</span>
                                {{ row.oldBonus | toMoney(row.currency) }}
                              </div>
                            </div>
                            <div class="col-12 p-0">
                              <div class="listy b-b">
																<span class="label">
																	{{ t.new_bonus}}
																</span>
                                {{ row.newBonus | toMoney(row.currency) }}
                              </div>
                            </div>
                            <div class="col-12 p-0">
                              <div class="listy b-b">
																<span class="label">
																	Note
																</span>
                                {{ row.note }}
                              </div>
                            </div>

                            <div class="col-12 p-0" v-if="row.gameId">
                              <div class="listy b-b">
																<span class="label">
																	Game
																</span>
                                <gameCard v-if="row.gameId" :vendor="row.provider" :gameId="row.gameId" />
                              </div>
                            </div>
                          </div>
                        </b-popover>
                      </td>
                      <td class="w20 text-center">
                        <router-link v-tooltip="t.transaction_manage" :to="{query: $route.query, params: {id: row.id} }">
                          <i class="icon-settings"></i>
                        </router-link>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">

                      </td>
                      <td class="text-danger text-right">
                        {{ total.result }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

								<div class="mobile-content" v-if="w < 700">

									<div class="element-box relative" v-for="row in transactions">

										<div class="row p-0">
											<div class="col-6 p-0">
												<div class="listy b-b">
													<span class="label">
														#
													</span>
													{{ row.id }}
												</div>
											</div>
											<div class="col-6 p-0">
												<div class="listy b-b">
													<span class="label">
														{{ t.amount }}
													</span>
													{{ row.amount | toMoney(row.currency) }}
												</div>
											</div>
											<div class="col-6 p-0">
												<div class="listy b-b">
													<span class="label">
														{{ t.transaction }}
													</span>
													{{ row.info }}
												</div>
											</div>
											<div class="col-6 p-0">
												<div class="listy b-b">
													<span class="label">
														{{ t.created_at }}
													</span>
													{{ dateTimeFormat(row.addedAt) }}
												</div>
											</div>
										</div>
									</div>

								</div>

								<paginate v-if="pagination"
								          :page-count="pagination.pageCount"
								          :page-range="pagination.pageRange"
								          :force-page="(pagination.current-1)"
								          :margin-pages="2"
								          :click-handler="onChangePage"
								          :prev-text="t.previous"
								          :next-text="t.next"
								          :container-class="'pagination float-right'"
								          :page-class="'page-item'"
								          :page-link-class="'page-link'"
								          :prev-class="'page-item'"
								          :prev-link-class="'page-link'"
								          :next-class="'page-item'"
								          :next-link-class="'page-link'"
								>
								</paginate>
							</div>
						</div>
						<!--END - User List -->
					</div>
				</div>
			</div>

			<!--------------------
START - Sidebar
-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper pt-4">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
						<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse id="filter" class="mt-2">
							<filterGenerator :filter="filter"></filterGenerator>
						</b-collapse>
					</div>
				</div>
			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>

		<sweet-modal ref="umodal" v-on:close="closeModal">

			<transactionDetail :id="$route.params.id" v-if="$route.params.id" />

		</sweet-modal>
	</div>
</template>

<script>
    import gameCard from '@/components/casino/gameCard'
    import transactionDetail from '@/components/accounting/transactionDetail'
    import filterGenerator from '@/components/form/filter'
    import { TableComponent, TableColumn } from 'vue-table-component'
    export default {
        name: 'transaction',
	    components: { 'table-component': TableComponent, 'table-column': TableColumn, filterGenerator, transactionDetail, gameCard},
        data () {
            return {
                api: window.api,
                w: window.innerWidth,
                isLoading: false,
                transactions: null,
                pagination: null,
                t: this.$root.t,
	              status: 0,
                types: null,
                promotions: null,
                filter: {},
                total: []
            }
        },
        watch: {
            '$route.name' () {
              setTimeout(this.fetchTransactions(), 1000);
              this.filterFixture();
            },
            '$route.query' () {
                this.fetchTransactions();
            },
            '$route.params.id' () {
                if (this.$route.params.id > 0) {
                    this.openModal();
                }
            }
        },
	    mounted () {
            this.fetchCurrencies();
            this.fetchTypies();
            this.filterFixture();
            this.fetchTransactions();
            this.fetchPromotions();

            if (this.$route.params.id > 0) {
                this.openModal();
            }
	    },
	    methods: {
            closeModal () {
                this.$router.push({query: this.$route.query, params: {id: 0}});

                setTimeout(() => {
                    document.body.style.overflow='auto';
            }, 500);
            },
            openModal () {
                this.$refs.umodal.open();
            },
            fiterNow () {
                this.$router.push({ query: this.filter.model });
            },
            onChangePage (page) {
                this.pagination.current = page;

                this.$route.query.page = page;
                var qr = this.$route.query;
                this.$router.push({});

                this.$router.push({ query: qr });

                this.filter.model.page = page;

                window.scroll(0, 0);
            },
            fetchTransactions () {

                if (!this.isLoading) {
                    this.isLoading = true;

                    if(this.$route.name === 'transactions'){
                      var params = this.$route.query;

                    }else {
                      this.$route.query.type = this.filter.model.type;
                      var params = this.$route.query;
                    }


                    this.$http.get(api+'api/v1/user/transactions?noCache=1', {params: params }).then(response => {
                        // get body data
                        this.transactions = response.body.result.transactions;
                        this.pagination = response.body.result.pagination;
                        this.isLoading = false;
                        this.status = response.status;
                        this.total = response.body.result.total;

                    }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    })


                }
            },
            filterFixture () {

              this.casinoFilter = {
                model: {
                  page: 1,
                  uid: '',
                  game: '',
                  username: '',
                  currencies: [],
                  type: [2,3,4,22,38,39,40,42,41,43,44,20,19],
                  promotions: [],
                  rangeDateTime: '',
                  rangeAmount: {}
                },
                schema: {
                  groups: [
                    {
                      legend: 'Genel',
                      fields: [
                        {
                          type: "input",
                          inputType: "number",
                          label: this.t.user.id,
                          model: "uid",
                          readonly: false,
                          featured: false,
                          disabled: false
                        },
                        {
                          type: "User",
                          label: this.t.user.username,
                          model: "uid",
                          readonly: false,
                          featured: false,
                          disabled: false
                        },
                        {
                          type: "Games",
                          label: 'Game',
                          model: "game",
                          readonly: false,
                          featured: false,
                          disabled: false
                        },
                        {
                          type: "AmountRange",
                          label: this.t.amount_range,
                          model: "rangeAmount",
                          readonly: false,
                          featured: false,
                          disabled: false
                        },
                        {
                          type: "Datepicker",
                          class: 'test',
                          label: this.t.created_at,
                          model: "rangeDateTime",
                          readonly: false,
                          featured: false,
                          disabled: false,
                          options: {
                            not_before: null,
                            clearable: true,
                            range: true,
                            firstDay: 1,
                            type: 'datetime',
                            format: 'YYYY-MM-DD HH:mm:ss',
                            dataFormat: 'YYYY-MM-DD HH:mm:ss',
                          }
                        },
                        {
                          type: "checklist",
                          label: this.t.transaction,
                          model: "type",
                          multi: true,
                          required: false,
                          multiSelect: true,
                          values: this.types,
                          checklistOptions: {
                            value: "id",
                            name: "info"
                          }
                        },
                        {
                          type: "checklist",
                          label: this.t.finance.currency,
                          model: "currencies",
                          multi: true,
                          required: false,
                          multiSelect: true,
                          values: this.currencies,
                          checklistOptions: {
                            value: "id",
                            name: "iso_code"
                          }
                        },
                        {
                          type: "checklist",
                          label: this.t.payment_methods,
                          model: "payments",
                          multi: true,
                          required: false,
                          multiSelect: true,
                          values: this.payment_methods,
                          checklistOptions: {
                            value: "id",
                            name: "title"
                          }
                        },
                        {
                          type: "checklist",
                          label: this.t.promotions,
                          model: "promotions",
                          multi: true,
                          required: false,
                          multiSelect: true,
                          values: this.promotions,
                          checklistOptions: {
                            value: "id",
                            name: "title"
                          }
                        },
                        {
                          type: "submit",
                          label: "",
                          buttonText: this.t.filter.title,
                          onSubmit: this.fiterNow,
                          validateBeforeSubmit: false,
                        }
                      ]
                    },
                  ],
                },
                options: {
                  validateAfterLoad: true,
                  validateAfterChanged: true
                }
              }

                this.filter = {
                    model: {
                        page: 1,
                        uid: '',
                        username: '',
                        currencies: [],
                        type: [],
                        promotions: [],
                        rangeDateTime: '',
                        rangeAmount: {}
                    },
                    schema: {
                        groups: [
                            {
                                legend: 'Genel',
                                fields: [
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: this.t.user.id,
                                        model: "uid",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "User",
                                        label: this.t.user.username,
                                        model: "uid",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "AmountRange",
                                        label: this.t.amount_range,
                                        model: "rangeAmount",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.created_at,
                                        model: "rangeDateTime",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            type: 'datetime',
                                            format: 'YYYY-MM-DD HH:mm:ss',
                                            dataFormat: 'YYYY-MM-DD HH:mm:ss',
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.transaction,
                                        model: "type",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.types,
                                        checklistOptions: {
                                            value: "id",
                                            name: "info"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.finance.currency,
                                        model: "currencies",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.currencies,
                                        checklistOptions: {
                                            value: "id",
                                            name: "iso_code"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.payment_methods,
                                        model: "payments",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.payment_methods,
                                        checklistOptions: {
                                            value: "id",
                                            name: "title"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.promotions,
                                        model: "promotions",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.promotions,
                                        checklistOptions: {
                                            value: "id",
                                            name: "title"
                                        }
                                    },
                                    {
                                        type: "submit",
                                        label: "",
                                        buttonText: this.t.filter.title,
                                        onSubmit: this.fiterNow,
                                        validateBeforeSubmit: false,
                                    }
                                ]
                            },
                        ],
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }

                this.filter = (this.$route.name === 'transactions') ? this.filter : this.casinoFilter;
            },

            async fetchCurrencies () {
                this.$http.get(api+'api/v1/currencies')
                    .then(response => {

                        this.currencies = response.body.result.currencies;
                        this.filterFixture();
                    }, response => {

                    })
            },
            async fetchTypies () {
                this.$http.get(api+'api/v1/user/transactions/types')
                    .then(response => {

                        this.types = response.body.result;
                        this.filterFixture();
                    }, response => {

                    })
            },
            async fetchPromotions () {
              this.$http.get(api+'api/v1/promotions?noCache=1').then(response => {
                  // get body data
                  this.promotions = response.body.promotions;
                    this.filterFixture();

              }, response => {
              })
            },
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table-lg td {
  padding: 5px !important;
  font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// src/components/accounting/transactions.vue